import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Auth from '../Components/auth';

function History() {
    const [transactions, setTransactions] = useState([]);
    const [totals, setTotals] = useState({
        usdt: { debit: 0, credit: 0 },
        raino: { debit: 0, credit: 0 }
    });

    const userId = localStorage.getItem('id'); // or wherever you're storing it

    useEffect(() => {
        if (userId) {
            axios.get(`https://rainocoin.com/api/transaction.php?userid=${userId}`)
                .then(response => {
                    if (response.data.status) {
                        setTransactions(response.data.transactions || []);
                        setTotals(response.data.totals || {});
                    }
                })
                .catch(error => {
                    console.error("Error fetching transactions:", error);
                });
        }
    }, [userId]);

    return (
        <div>
            <Auth />
            <div className="header is-fixed">
                <div className="tf-container">
                    <div className="tf-statusbar d-flex justify-content-center align-items-center">
                        <Link to="/" className="back-btn"> <i className="icon-left" /> </Link>
                        <h3>History</h3>
                    </div>
                </div>
            </div>

            <div id="app-wrap">
                <div className="app-section st1 mt-1 bg_white_color">
                    <div className="tf-container">
                        <div className="wrap-total">
                            <div className="total-item">
                                <Link to="#" className="box-icon bg_critical">
                                    <i className="icon-arrow-up_minor critical_color arrow-down" />
                                </Link>
                                <div className="content">
                                    <p className="fw_4">USDT : ${totals.usdt?.credit?.toFixed(2) || '0.00'}</p>
                                    <p className="fw_4">RAINO : {totals.raino?.credit?.toFixed(2) || '0.00'}</p>
                                </div>
                            </div>
                            <div className="total-item">

                                <Link to="#" className="box-icon bg_primary">
                                    <i className="icon-arrow-up_minor primary_color" />
                                </Link>
                                <div className="content">
                                    <p className="fw_4">USDT : ${totals.usdt?.debit?.toFixed(2) || '0.00'}</p>
                                    <p className="fw_4">RAINO : {totals.raino?.debit?.toFixed(2) || '0.00'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Transaction List */}
                <div className="app-section st1 mt-1 mb-5 bg_white_color">
                    <div className="tf-container">
                        <div className="trading-month">
                            <div className="group-trading-history mb-5">
                                {transactions.map((tx, index) => (
                                    <div key={index} className="tf-trading-history">
                                        <div className="inner-left">
                                            <div className="icon-box">
                                                <i className="icon icon-mobile" />
                                            </div>
                                            <div className="content">
                                                <h4>{tx.remark || tx.currency}</h4>
                                                <p>{tx.dat_time}</p>
                                            </div>
                                        </div>
                                        <span className={`num-val ${tx.type === 'debit' ? 'critical_color' : 'success_color'}`}>
                                            {tx.type === 'debit' ? '-' : '+'} {parseFloat(tx.amount).toFixed(2)} {tx.currency}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer (unchanged) */}
            {/* ... footer code continues ... */}
        </div>
    );
}

export default History;
